import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { AuthProvider } from "./components/AuthContext";
import "./styles.css";
import "./features.css";
import "./features2.css";
import "./responsive.css";
import "./features3.css";
import "./redo.css";
import "./venice.css";
import "./creator.css";
import "./campaign-media-forward.css";
import "./dialect-coach.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider><App/></AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
